import { Component, EventEmitter, Input, NO_ERRORS_SCHEMA, OnInit, Output } from '@angular/core';
import { RemarketingUiComponentsLibModule, TableDisplayStyle, TableModule } from 'remarketing-ui-components-lib';
import { fromMatchMedia, SaComponent } from 'smartauction-frontend-micro-library';
import { map, takeUntil } from 'rxjs/operators';
import { Observable } from 'rxjs';
import { TranslocoService } from '@jsverse/transloco';
import { ViwInventoryRecord } from 'remarketing-angular-library';
import { CommonModule } from '@angular/common';


@Component({
    selector: 'app-third-party-posting-search-results',
    templateUrl: './third-party-posting-search-results.component.html',
    styleUrls: ['./third-party-posting-search-results.component.scss'],
    imports: [CommonModule, RemarketingUiComponentsLibModule, TableModule],
    schemas: [NO_ERRORS_SCHEMA]
})
export class ThirdPartyPostingSearchResultsComponent extends SaComponent implements OnInit {
  thirdPartyTableTranslations = {
    vin: 'VIN',
    vendor: '',
    year: '',
    make: '',
    model: '',
    trim: '',
    dealerStockNumber: '',
    odometer: ''
  };
  tableCaption = '';
  notAvailableText = '';

  @Input() thirdPartySearchResults: ViwInventoryRecord[];
  @Output() proceedWithThirdPartyVin = new EventEmitter<ViwInventoryRecord>();

  vehicleTableStyle$: Observable<TableDisplayStyle> = fromMatchMedia('(max-width: 768px)').pipe(
    takeUntil(this.destroyed$),
    map(({matches}) => (matches ? 'cards' : 'table'))
  );

  constructor(private readonly translocoService: TranslocoService) {
    super();
  }

  ngOnInit(): void {
    this.getTranslations();
  }

  getTranslations() {
    const translationKeys = {
      'common': {},
      'sellModule.posting.thirdParty': {}
    };

    this.translocoService.selectTranslateObject(translationKeys)
      .pipe(takeUntil(this.destroyed$))
      .subscribe(translationFields => {
        this.notAvailableText = translationFields[0].notAvailable;
        this.thirdPartyTableTranslations.year = translationFields[1].yearLabel;
        this.thirdPartyTableTranslations.dealerStockNumber = translationFields[1].dealerStockNumberLabel;
        this.thirdPartyTableTranslations.make = translationFields[1].makeLabel;
        this.thirdPartyTableTranslations.model = translationFields[1].modelLabel;
        this.thirdPartyTableTranslations.odometer = translationFields[1].odometerLabel;
        this.thirdPartyTableTranslations.trim = translationFields[1].trimLabel;
        this.thirdPartyTableTranslations.vendor = translationFields[1].vendorLabel;
        this.tableCaption = translationFields[1].thirdPartyTableCaption;
      }, error => {
        console.log(error);
      });
  }

  get columns() {
    return Object.keys(this.thirdPartyTableTranslations);
  }
}
